import { useSpring, animated } from "@react-spring/web";
import React from "react";
import styled from "styled-components";

const OnBoardingIcon = () => {
  const movement = 20;
  const movenmentHorizontal = 10;
  const animation = useSpring({
    from: {
      transform: `translateY(-${movement}px)`,
    },
    to: [
      { transform: `translateY(${movement}px)` },
      { transform: `translateY(-${movement}px)` },
    ],
    config: {
      duration: 500,
    },
    // reset: true,
    // reverse: true,
    loop: true,
  });
  const animationHorizontal = useSpring({
    from: {
      transform: `translateX(-${movenmentHorizontal}px)`,
    },
    to: [
      { transform: `translateX(${movenmentHorizontal}px)` },
      { transform: `translateX(-${movenmentHorizontal}px)` },
    ],
    config: {
      duration: 500,
    },
    // reset: true,
    // reverse: true,
    loop: true,
  });

  // const animationCalendar = useSpring({
  //   from: {
  //     transform: `translateX(${initialPosition}px)`,
  //   },
  //   to: {
  //     transform: `translateX(${finalPosition}px)`,
  //   },
  //   config: {
  //     duration: 1000,
  //     // tension: 200,
  //     // friction: 10,
  //   },
  //   loop: true,
  // });
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="320"
      height="284"
      fill="none"
      viewBox="0 0 293 284"
    >
      <path
        fill="#FD9401"
        d="M138.218 249.864c59.909 0 108.475-48.272 108.475-107.818S198.127 34.228 138.218 34.228c-59.91 0-108.476 48.272-108.476 107.818s48.566 107.818 108.476 107.818z"
        opacity="0.1"
      ></path>

      <animated.path
        // className="location-animation"
        style={animation}
        fill="#FD9401"
        fillRule="evenodd"
        d="M71.682 84.134L55.746 46.651c-4.855-11.424 3.53-24.073 15.936-24.073S92.473 35.252 87.62 46.65L71.682 84.134z"
        clipRule="evenodd"
      ></animated.path>

      <animated.path
        style={animation}
        fill="#fff"
        fillRule="evenodd"
        d="M82.247 40.18c0 5.834-4.731 10.565-10.567 10.565-5.835 0-10.567-4.731-10.567-10.566 0-5.834 4.732-10.566 10.567-10.566 5.836 0 10.567 4.732 10.567 10.566z"
        clipRule="evenodd"
      ></animated.path>
      <path
        fill="#2F3F59"
        d="M146.418 0h-8.508v112.571h8.508V0zM182.219 0h-8.508v112.571h8.508V0z"
      ></path>
      <path
        fill="#5AB2D0"
        d="M232.594 96.49H87.524v161.92h145.07V96.49z"
      ></path>
      <path
        fill="#7DD1E6"
        d="M232.594 96.49H87.524c0-7.208 5.835-13.042 13.043-13.042h119.008c7.208 0 13.044 5.834 13.044 13.041h-.025z"
      ></path>
      <path
        fill="#0092B1"
        d="M87.52 258.409h145.071c0 7.207-5.835 13.042-13.043 13.042H100.539c-7.208 0-13.043-5.835-13.043-13.042h.025z"
      ></path>
      <path
        fill="#D7F8FF"
        d="M215.055 83.448H105.02v187.978h110.035V83.448z"
        opacity="0.19"
      ></path>
      <path
        fill="#0092B1"
        d="M200.056 179.423H120.08a5.271 5.271 0 00-5.271 5.271v58.762a5.27 5.27 0 005.271 5.27h79.976a5.27 5.27 0 005.272-5.27v-58.762a5.271 5.271 0 00-5.272-5.271z"
      ></path>
      <path
        fill="#5AB2D0"
        d="M205.328 190.16h-90.519v48.711h90.519V190.16z"
        opacity="0.2"
      ></path>
      <path
        fill="#fff"
        d="M205.328 212.788h-90.519v3.432h90.519v-3.432z"
      ></path>
      <path
        fill="#2F3F59"
        d="M114.532 283.684h-6.742l-2.77-12.258h12.258l-2.746 12.258zM212.32 283.684h-6.742l-2.746-12.258h12.259l-2.771 12.258z"
      ></path>
      <path fill="#0092B1" d="M182.189 0H137.91v11.865h44.279V0z"></path>
      <path
        fill="#D7F8FF"
        d="M146.168 0h27.803v5.59a3.338 3.338 0 01-3.334 3.333h-21.135a3.338 3.338 0 01-3.334-3.334V0z"
        opacity="0.19"
      ></path>
      <path
        fill="#2F3F59"
        d="M113.264 107.767a3.677 3.677 0 100-7.355 3.677 3.677 0 000 7.355zM210.523 104.09a3.672 3.672 0 01-3.677 3.677 3.673 3.673 0 01-3.678-3.677 3.673 3.673 0 013.678-3.678 3.672 3.672 0 013.677 3.678z"
      ></path>
      <path
        fill="#EE5040"
        d="M89.242 145.03h-35.11v-23.927c0-9.683 7.871-17.552 17.555-17.552 9.685 0 17.555 7.869 17.555 17.552v23.927zm-29.617-5.516h24.1v-18.411c0-6.643-5.393-12.036-12.038-12.036-6.644 0-12.038 5.417-12.038 12.036v18.411h-.024z"
      ></path>
      <path
        fill="#FD9401"
        d="M13.157 206.879H23.92v54.84H13.157c-7.012 0-12.7-5.688-12.7-12.699v-29.442c0-7.011 5.688-12.699 12.7-12.699zM130.23 261.744h-10.764v-54.84h10.764c7.012 0 12.7 5.688 12.7 12.699v29.442c0 7.011-5.688 12.699-12.7 12.699z"
      ></path>
      <path
        fill="#EE5040"
        d="M123.677 195.946H19.697a7.502 7.502 0 00-7.502 7.502v72.759a7.502 7.502 0 007.503 7.502h103.979a7.502 7.502 0 007.502-7.502v-72.759a7.502 7.502 0 00-7.502-7.502z"
      ></path>
      <path
        fill="#2F3F59"
        d="M71.68 126.349c25.989 0 47.099 21.107 47.099 47.093v22.504H24.582v-22.504c0-25.986 21.11-47.093 47.098-47.093z"
      ></path>
      <path
        fill="#FD9401"
        d="M115.344 207.395H28.037a4.56 4.56 0 00-4.56 4.559v43.514a4.56 4.56 0 004.56 4.56h87.307a4.56 4.56 0 004.56-4.56v-43.514a4.559 4.559 0 00-4.56-4.559z"
      ></path>
      <path
        fill="#D7F8FF"
        d="M107.816 207.395H35.562v52.633h72.254v-52.633z"
        opacity="0.19"
      ></path>
      <path
        fill="#E2382D"
        d="M12.195 271.427v4.756a7.501 7.501 0 007.503 7.501H123.7a7.502 7.502 0 007.503-7.501v-4.756H12.195z"
      ></path>
      <path fill="#fff" d="M119.904 224.555H23.477v2.55h96.427v-2.55z"></path>
      <path
        fill="#7DD1E6"
        d="M47.313 153.512h48.741a3.83 3.83 0 013.825 3.825v27.971h-56.39v-27.971a3.83 3.83 0 013.824-3.825z"
      ></path>
      <animated.path
        style={animationHorizontal}
        fill="#2F3F59"
        d="M282.15 127.207h-91.181c-5.836 0-10.567 4.731-10.567 10.566v91.17c0 5.835 4.731 10.566 10.567 10.566h91.181c5.836 0 10.568-4.731 10.568-10.566v-91.17c0-5.835-4.732-10.566-10.568-10.566z"
      ></animated.path>
      <animated.path
        style={animationHorizontal}
        fill="#EE5040"
        d="M282.15 127.207h-91.181c-5.835 0-10.567 4.731-10.567 10.566v21.744h112.316v-21.744c0-5.835-4.732-10.566-10.568-10.566z"
      ></animated.path>
      <animated.path
        style={animationHorizontal}
        fill="#fff"
        d="M220.365 151.845a4.701 4.701 0 01-1.814-1.397l1.667-2.011c.711.956 1.52 1.422 2.427 1.422 1.226 0 1.839-.711 1.839-2.157V141.5h-4.585v-2.427h7.576v8.457c0 1.594-.392 2.795-1.201 3.604-.809.809-1.962 1.201-3.506 1.201a6.036 6.036 0 01-2.427-.49h.024zM231.916 150.791c-1.03-1.03-1.545-2.501-1.545-4.413v-7.305h3.016v7.183c0 2.328.956 3.505 2.893 3.505.932 0 1.667-.269 2.157-.858.491-.564.736-1.446.736-2.647v-7.183h2.967v7.305c0 1.912-.515 3.383-1.545 4.413-1.03 1.029-2.476 1.544-4.34 1.544-1.863 0-3.31-.515-4.339-1.544zM257.09 139.073v13.042h-2.477l-6.497-7.919v7.919h-2.991v-13.042h2.501l6.472 7.918v-7.918h2.992zM236.095 208.621v5.614h-22.459v-4.462l11.475-10.835c2.623-2.501 3.113-4.045 3.113-5.467 0-2.329-1.618-3.702-4.756-3.702-2.55 0-4.707.981-6.154 2.967l-5.002-3.236c2.305-3.359 6.449-5.516 11.818-5.516 6.62 0 11.033 3.407 11.033 8.801 0 2.892-.809 5.515-4.977 9.389l-6.841 6.447h12.774-.024zM263.409 204.821c0 6.08-4.977 9.904-11.253 9.904-8.189 0-13.289-5.148-13.289-14.733 0-10.272 6.203-16.008 15.152-16.008 3.138 0 6.203.711 8.287 2.035l-2.55 5.05c-1.667-1.104-3.579-1.496-5.565-1.496-4.977 0-8.165 2.942-8.361 8.629 1.741-1.74 4.242-2.623 7.355-2.623 5.738 0 10.224 3.653 10.224 9.267v-.025zm-6.668.344c0-2.722-1.986-4.462-5.051-4.462-3.065 0-5.149 1.863-5.149 4.462 0 2.598 1.913 4.412 5.222 4.412 2.943 0 4.978-1.691 4.978-4.412z"
      ></animated.path>
      <path
        stroke="#2F3F59"
        strokeMiterlimit="10"
        d="M40.995 103.281H8.215M24.59 119.681V86.905M279.783 40.18h-32.756M263.402 56.556V23.804"
      ></path>
    </svg>
  );
};

export default OnBoardingIcon;
